module.exports = __webpack_public_path__ + "media/images/features/modification/heading-mv-429253982655339b3584cd798037d94f.svg";